import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { AppOutOfDateModalViewModel } from './app-out-of-date-modal-view-model';

@Component({
  selector: 'app-app-out-of-date-modal',
  templateUrl: './app-out-of-date-modal.component.html',
  styleUrls: ['./app-out-of-date-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AppOutOfDateModalViewModel],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AppOutOfDateModalComponent {
  constructor(public viewModel: AppOutOfDateModalViewModel) {}
}
